document.addEventListener('DOMContentLoaded', function () {
  function styleAndPlay(vid) {
    var wrapper = vid.closest('.media--autoplay');
    if (wrapper) {
      wrapper.style.position = 'relative';
      wrapper.style.overflow = 'hidden';
      wrapper.style.width = '100%';
    }
    vid.style.position = 'absolute';
    vid.style.top = '0';
    vid.style.left = '0';
    vid.style.width = '100%';
    vid.style.height = '100%';
    vid.style.objectFit = 'cover';
    vid.muted = true;
    vid.setAttribute('muted', '');
    vid.setAttribute('playsinline', '');
    vid.setAttribute('webkit-playsinline', '');
    vid.loop = true;
    vid.removeAttribute('controls');
    vid.removeAttribute('poster');
    var p = vid.play();
    if (p !== undefined) { p.catch(function () {}); }
  }

  function initAutoplayVideos() {
    document.querySelectorAll('.media--autoplay video').forEach(styleAndPlay);
  }

  initAutoplayVideos();
  window.addEventListener('load', initAutoplayVideos);
  setTimeout(initAutoplayVideos, 500);
  setTimeout(initAutoplayVideos, 1500);
});